import { render, staticRenderFns } from "./customerServiceWorkbench.vue?vue&type=template&id=f0f4cac2&"
import script from "./customerServiceWorkbench.vue?vue&type=script&lang=js&"
export * from "./customerServiceWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceWorkbench.vue?vue&type=style&index=0&id=f0f4cac2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports